import { domUtils } from "./domUtils";

export const uiManager = {
  addFieldError: (field, message) => {
    if (!field || !message) return;

    // Clear any existing error first
    uiManager.removeFieldError(field);

    const errorContainer = document.createElement("div");
    errorContainer.className = "form-field-message bad";
    errorContainer.textContent = message;

    const wrapper = domUtils.findFieldWrapper(field);

    if (wrapper) {
      wrapper.appendChild(errorContainer);
      wrapper.classList.add("has-error");
    }

    if (field.length === undefined) {
      field.classList.add("has-error");
    }

    uiManager.setupErrorClearingListeners(field);
  },

  removeFieldError: (field) => {
    const wrapper = domUtils.findFieldWrapper(field);

    if (!wrapper) {
      return;
    }

    const errorContainer = wrapper.querySelector(".form-field-message");

    if (errorContainer) {
      errorContainer.remove();
      wrapper.removeEventListener("change", wrapper.errorClearHandler);
      delete wrapper.errorClearHandler;

      wrapper.classList.remove("has-error");

      if (field.length === undefined) {
        field.classList.remove("has-error");
      }
    }
  },

  setupErrorClearingListeners: (field) => {
    const wrapper = domUtils.findFieldWrapper(field);

    if (!wrapper) {
      return;
    }

    if (wrapper.errorClearHandler) {
      wrapper.removeEventListener("change", wrapper.errorClearHandler);
    }

    wrapper.errorClearHandler = () => uiManager.removeFieldError(field);
    wrapper.addEventListener("change", wrapper.errorClearHandler, { once: true });
  },

  updateFormUI: (form, errors) => {
    uiManager.clearFormErrors(form);

    Object.entries(errors).forEach(([fieldName, fieldErrors]) => {
      const field = form.elements[fieldName];
      if (!field || !fieldErrors.length) return;

      const errorContainer = document.createElement("div");
      errorContainer.className = "form-field-message bad";
      errorContainer.textContent = fieldErrors[0];

      const wrapper = domUtils.findFieldWrapper(field);

      if (wrapper) {
        wrapper.appendChild(errorContainer);
        wrapper.classList.add("has-error");
      }

      if (field.length === undefined) {
        field.classList.add("has-error");
      }

      uiManager.setupErrorClearingListeners(field);
    });
  },

  clearFormErrors: (form) => {
    form.querySelectorAll("input, select, textarea").forEach(uiManager.removeFieldError);
  },
};
